import {
  faAngleDown,
  faAngleUp,
  faCaretDown,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Button, Col, Row } from "react-bootstrap";
import "../../booking/flight-selection/FlightSelection.css";
import Translation from "i18next";
import ItineraryBrand from "../../booking/flight-selection/itinerary-part-offer/ItineraryPartBrand";
import ExchangeFlightDetail from "../ExchangeFlightDetail";
import ExchangeFlightSelectionDetail from "./ExchangeFlightSelectionDetail";
import ExchangeItineraryPartOfferMob from "./mob/ExchangeItineraryPartOfferMob";
import ExchangeItineraryBrand from "./ExchangeItineraryBrand";
class ExchangeItineraryPartOffer extends Component {
  state = {};
  constructor(props) {
    super(props);
    this.state = {
      showItineraryOffer: false,
      isEconomySelected: false,
      isBusinessSelected: false,
      itineraryPartBrand: this.props.itineraryPartBrand,
    };
  }

  parseTime = (minute) => {
    let hours = parseInt(minute / 60);
    let minutes = minute % 60;
    return <span>{hours + "hrs " + minutes + " mins"}</span>;
  };
  parseDate = (dateString) => {
    let options = {
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    };
    let date = new Date(dateString);
    let newDate = date.toLocaleString("en-GB", options);
    return <span>{newDate}</span>;
  };

  renderStops(segments, stops) {
    if (stops > 0) {
      if (segments.length > 1) {
        return (
          <span>
            <span>
              {stops > 1
                ? stops + " " + Translation.t("stops")
                : stops + " " + Translation.t("stop")}
            </span>
          </span>
        );
      } else {
        return (
          <span>
            <span>
              {stops > 1
                ? stops + " " + Translation.t("stops")
                : stops + " " + Translation.t("stop")}
            </span>
            {segments.map((segment, index) => (
              <span key={index}>
                {segment.flight.stopAirports.map((airport, index2) => (
                  <span key={index2}>{" " + airport.airport}</span>
                ))}
              </span>
            ))}
          </span>
        );
      }
    } else {
      return <span>{Translation.t("non-stop")}</span>;
    }
  }
  render() {
    return (
      <div>
        <div className={"itinerary-part-offer py-4 mt-" + this.props.marginTop}>
          <Row>
            <Col lg={7} md={7}>
              {this.props.itineraryPartBrand.itineraryPart.map(
                (itinerary, key) => (
                  <div>
                    <Row key={key}>
                      <Col lg={7} md={7}>
                        <Row className="flight-time">
                          <Col>
                            {this.parseDate(itinerary.segments[0].departure)}
                          </Col>
                          <Col className="pl-4">
                            {this.parseDate(
                              itinerary.segments[itinerary.segments.length - 1]
                                .arrival
                            )}
                          </Col>
                        </Row>
                        <Row className="flight-route">
                          <Col>
                            {" "}
                            <span className="font-weight-bold">
                              {itinerary.segments[0].origin}
                            </span>
                          </Col>
                          <Col className="pl-4">
                            {" "}
                            <span className="font-weight-bold">
                              {
                                itinerary.segments[
                                  itinerary.segments.length - 1
                                ].destination
                              }
                            </span>
                          </Col>
                        </Row>
                      </Col>
                      <Col lg={5} md={5} className="flight-duration">
                        <div>
                          {" "}
                          <span>{this.parseTime(itinerary.totalDuration)}</span>
                        </div>
                        <div>
                          <span>
                            {this.renderStops(
                              itinerary.segments,
                              itinerary.stops
                            )}
                          </span>
                        </div>
                      </Col>

                      <Col xs={12} className="py-2 aircraft-info">
                        {itinerary.segments.map((segment, index) => (
                          <div className="py-1" key={index}>
                            {segment.flight.airlineCode === "ET" && (
                              <img
                                className="custom-img-sm-flag"
                                src="data:image/png;base64,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"
                              />
                            )}
                            <span className="px-1">
                              {segment.flight.airlineCode}
                            </span>
                            <span className="pr-2">
                              {segment.flight.flightNumber}
                            </span>
                            <span className="pr-2">
                              {segment.manufacturerName}
                            </span>
                            <span>{segment.equipmentDescription}</span>
                          </div>
                        ))}
                      </Col>
                    </Row>
                    {key <
                      this.props.itineraryPartBrand.itineraryPart.length -
                        1 && <hr />}
                  </div>
                )
              )}
            </Col>
            <Col lg={5} md={5}>
              <Row>
                <Col lg={6} md={6}>
                  <div>
                    {this.props.itineraryPartBrand.echeepPrice != "N/A" && (
                      <Button
                        className="brand-price-selector eco"
                        onClick={() => {
                          const tesNode = ReactDOM.findDOMNode(this.refs.test);
                          if (!this.state.isEconomySelected)
                            window.scrollTo({
                              top: tesNode.offsetTop - 340,
                              behavior: "smooth",
                            }); //(0, tesNode.offsetTop - 320, );

                          this.setState({
                            isEconomySelected: !this.state.isEconomySelected,
                            isBusinessSelected: false,
                          });
                        }}
                      >
                        <div>{Translation.t("from")}</div>
                        <div>
                          <span>
                            {this.props.itineraryPartBrand.echeepPrice}
                          </span>{" "}
                          {!this.state.isEconomySelected && (
                            <span className="pl-1">
                              <FontAwesomeIcon icon={faAngleDown} />
                            </span>
                          )}
                          {this.state.isEconomySelected && (
                            <span className="pl-1">
                              <FontAwesomeIcon icon={faAngleUp} />
                            </span>
                          )}
                        </div>
                      </Button>
                    )}
                  </div>
                </Col>
                <Col lg={6} md={6}>
                  <div>
                    {this.props.itineraryPartBrand.bcheepPrice != "N/A" && (
                      <Button
                        className="brand-price-selector bus"
                        onClick={() => {
                          const tesNode = ReactDOM.findDOMNode(this.refs.test);
                          if (!this.state.isBusinessSelected)
                            window.scrollTo({
                              top: tesNode.offsetTop - 340,
                              behavior: "smooth",
                            });
                          this.setState({
                            isBusinessSelected: !this.state.isBusinessSelected,
                            isEconomySelected: false,
                          });
                        }}
                      >
                        <div>{Translation.t("from")}</div>
                        <div>
                          <span>
                            {this.props.itineraryPartBrand.bcheepPrice}
                          </span>{" "}
                          {!this.state.isBusinessSelected && (
                            <span className="pl-1">
                              <FontAwesomeIcon icon={faAngleDown} />
                            </span>
                          )}
                          {this.state.isBusinessSelected && (
                            <span className="pl-1">
                              <FontAwesomeIcon icon={faAngleUp} />
                            </span>
                          )}
                        </div>
                      </Button>
                    )}
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <ExchangeFlightSelectionDetail
                itineraryPart={this.props.itineraryPartBrand.itineraryPart}
              />
            </Col>
          </Row>
          <div ref="test">
            {/* <ItineraryBrand
           
            /> */}
            <ExchangeItineraryBrand
              isEconomySelected={this.state.isEconomySelected}
              isBusinessSelected={this.state.isBusinessSelected}
              itineraryPartBrand={this.props.itineraryPartBrand}
              selectFlight={this.props.selectFlight}
            />
          </div>
        </div>
        <div id="itinerary-part-offer-mob">
          <ExchangeItineraryPartOfferMob
            selectFlight={this.props.selectFlight}
            marginTop={4}
            index={this.props.index}
            itineraryPartBrand={this.props.itineraryPartBrand}
          />
        </div>
      </div>
    );
  }
}
export default ExchangeItineraryPartOffer;
